import { csx } from '@vtex/admin-ui'

export const styles = {
  radioGroup: csx({
    '> div > div > div': {
      width: '100%',
    },
    'div[data-wrap="true"]': {
      flexWrap: 'nowrap',
    },
    'input[type="radio"]': {
      minWidth: '1.25rem',
    },
  }),
  collapsible: csx({
    display: 'flex',
    flexDirection: 'column',
    userSelect: 'none',
  }),
  collapsibleHeader: csx({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '$space-2',
  }),
  collapsibleHeaderActions: csx({
    display: 'flex',
    alignItems: 'center',
    gap: '$space-2',
  }),
  collapsibleTitle: csx({
    display: 'flex',
    alignItems: 'center',
    gap: '$space-4',
  }),
  collapsibleContent: csx({
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-2',
  }),
  collapsibleActions: csx({
    marginTop: '$space-4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '> div': {
      gap: '$space-1',
    },
  }),
  alert: csx({ marginTop: '$space-4', paddingLeft: '$space-7', width: '100%' }),
  items: csx({ paddingTop: '$space-2' }),
  nonHoverable: csx({
    pointerEvents: 'none',
  }),
  counter: csx({
    outline: 'none',
  }),
  chip: csx({
    width: 'full',
    display: 'flex',
    border: '$neutral',
    borderRadius: 8,
    paddingY: '$space-3',
    paddingX: '$space-5',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    ':hover': { backgroundColor: '$secondary' },
    '[data-error="true"]': {
      border: '$form.critical',
    },
  }),
  addChipContainer: csx({
    display: 'flex',
    gap: '$space-2',
  }),
  addChip: csx({
    display: 'flex',
    border: '$neutral',
    borderRadius: 8,
    paddingY: '$space-2',
    paddingX: '$space-3',
    gap: '$space-2',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    ':hover': { backgroundColor: '$secondary' },
  }),
  removeButton: csx({
    opacity: 0,
    transition: 'opacity 0.1s',
  }),
  itemsEditor: csx({
    marginTop: '$space-6',
  }),
  emptyItems: csx({
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-2',
  }),
}
